import { Button, Input } from '@attentive-platform/stem-ui';

import CopyIcon from '../../../Assets/CopyIcon';

const ApiKeyGenerateSection = ({ newToken, generateLoading, onGenerate, handleCopy }) => {
  const endIcons = [
    {
      icon: CopyIcon,
      onClick: () => handleCopy()
    }
  ];
  
  return (
    <div className='flex flex-col gap-2 mb-2'>
      <label className='text-sm font-medium text-gray-700 block mb-1'>API Key</label>
      <div className='flex gap-2 mb-2 items-end'>
        <div className='w-full [&_input]:cursor-not-allowed'>
          <Input
            disabled
            className='w-full'
            endIcons={endIcons}
            placeholder='Generate API key'
            value={newToken}
          />
        </div>
        <Button color='primary' onClick={onGenerate} loading={generateLoading}>
          Generate
        </Button>
      </div>
    </div>
  );
};

export default ApiKeyGenerateSection;
